/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-14 09:30.
 * 密码加密
 */
const JSEncrypt = require( 'helper/jsencrypt' ).default;
const ENABLE_PASSWORD_ENCODE = true;
const publicKey = `MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJ1xJ8PjTc0PNb4q2Gnwui8f12+2eI7gXSb0P/BFcsU9qmQFCsxwnMuj6UfeC1IA6Rzz9yw81DipYCHVPH5KMu8CAwEAAQ==`;

const encrypt = new JSEncrypt();
encrypt.setPublicKey( publicKey );

function encode( text ) {
  return ENABLE_PASSWORD_ENCODE ? encrypt.encrypt( text ) : text;
}

module.exports = { encode };
